const WasyuProductCategories = ['赤ワイン', '白ワイン', 'ロゼワイン', 'スパークリングワイン', 'オレンジワイン', 'シードル/ポワレ', 'その他ワイン', 'ブランデー', 'ノンアルコール', 'ジュース', 'その他ソフトドリンク', '日本酒', 'フード', '雑貨', 'ギフト パッケージ' ];
const searchTagList = ['関連キーワード_新着','関連キーワード_予約','関連キーワード_再入荷','関連キーワード_限定','関連キーワード_受賞ワイン','関連キーワード_セール','関連キーワード_再値下げ','関連キーワード_送料無料'];

function insertCartButton(productElement, productObjectData) {
  const variantId = productObjectData.variants[0].id;
  const productUrl = productObjectData.url;
  const productTitle = productObjectData.title;
  const productImage = productObjectData.featured_image;
  const options = productObjectData.options.map(option => `${option.name}: ${option.values.join(', ')}`).join('; ');
  const isAvailable = productObjectData.available;

  // Find the nearest element with class "snize-price-list"
  const priceList = productElement.querySelector('.snize-price-list');
  if (priceList && !productElement.querySelector('.snize-cart-button')) { // Check if button already exists
    // Create the button and object as a template literal
    const buttonHtml = `
      <object type="owo/uwu">
        <button type="button" aria-label="カートに入れる" class="btn product-form__cart-submit snize-cart-button"
                data-variant-id="${variantId}" data-product-url="${productUrl}" data-product-title="${productTitle}" data-product-image="${productImage}" data-options="${options}"
                ${!isAvailable ? 'disabled' : ''}>
          <span data-add-to-cart-text="">
            <span class="${isAvailable ? 'p_cbtn' : ''}">${isAvailable ? 'カートに入れる' : '在庫がありません'}</span>
          </span>
          <span class="hide" data-loader="">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
              <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path>
            </svg>
          </span>
        </button>
      </object>
    `;

    // Insert the buttonHtml under the price list
    priceList.insertAdjacentHTML('afterend', buttonHtml);

    // Add event listener to the button if the product is available
    if (isAvailable) {
      const button = productElement.querySelector('.snize-cart-button');
      button.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default link action
        const buttonText = button.querySelector('[data-add-to-cart-text]');
        const loader = button.querySelector('[data-loader]');
        const cartPopupWrapper = document.querySelector('.cart-popup-wrapper');
        const cartPopupImageWrapper = cartPopupWrapper.querySelector('[data-cart-popup-image-wrapper]');

        // Add 'cart-popup-wrapper--hidden' class to cart popup wrapper
        if (cartPopupWrapper) {
          cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');
        }

        // Show loading spinner
        buttonText.classList.add('hide');
        loader.classList.remove('hide');

        addToCart(variantId)
          .done(response => {
            console.log('Added to cart:', response);

            // Remove 'cart-popup-wrapper--hidden' class from cart popup wrapper
            if (cartPopupWrapper) {
              cartPopupWrapper.style = '';
              cartPopupWrapper.classList.remove('cart-popup-wrapper--hidden');
            }

            // Fill the cart popup with product data
            cartPopupImageWrapper.innerHTML = `<img src="${productImage}" alt="${productTitle}" class="cart-popup-item__image" data-cart-popup-image="">`;
            cartPopupImageWrapper.classList.remove('hide'); // Remove hide class from image wrapper
            const cartPopupTitle = cartPopupWrapper.querySelector('[data-cart-popup-title]');
            const cartPopupDetails = cartPopupWrapper.querySelector('[data-cart-popup-product-details]');
            const cartPopupQuantityLabel = cartPopupWrapper.querySelector('[data-cart-popup-quantity-label]');
            const cartPopupQuantity = cartPopupWrapper.querySelector('[data-cart-popup-quantity]');
            const cartPopupCartQuantity = cartPopupWrapper.querySelector('[data-cart-popup-cart-quantity]');

            // Populate the cart popup
            cartPopupTitle.textContent = productTitle;
            cartPopupDetails.innerHTML = options.split('; ').map(option => `<li class="product-details__item product-details__item--variant-option">${option}</li>`).join('');
            cartPopupQuantityLabel.textContent = '数量: 1';
            cartPopupQuantity.textContent = '1';

            // Update the cart count
            const cartCountElement = document.querySelector('#CartCount [data-cart-count]');
            const currentCartCount = parseInt(cartCountElement.textContent, 10);
            const newCartCount = currentCartCount + 1;
            cartCountElement.textContent = newCartCount;

            // Update the cart popup count
            cartPopupCartQuantity.textContent = newCartCount;
            cartPopupCartQuantity.setAttribute('aria-label', `${newCartCount}個のアイテム`);
          })
          .fail((xhr, status, error) => {
            console.log('Error adding to cart:', xhr.responseJSON);
            if (xhr.status === 422) {
              // Check if error message already exists
              if (!button.nextElementSibling || !button.nextElementSibling.classList.contains('snize-cart-error')) {
                // Show error message
                const errorMessageHtml = `
                  <div class="snize-cart-error">
                    <span>在庫不足のためカートに入れられませんでした。</span>
                  </div>
                `;
                button.insertAdjacentHTML('afterend', errorMessageHtml);
              }
            } else {
              console.log('Error adding to cart.');
            }
          })
          .always(() => {
            // Hide loading spinner
            buttonText.classList.remove('hide');
            loader.classList.add('hide');
          });
      });
    }
  }
}

function addToCart(variantId) {
  return $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantId
    },
    dataType: 'json'
  });
}

// Function to add event listener to the close button
function addCloseButtonEventListener() {
  const closeButton = document.querySelector('.cart-popup__close');
  const dismissButton = document.querySelector('.cart-popup__dismiss-button');
  const cartPopupWrapper = document.querySelector('.cart-popup-wrapper');
  
  if (closeButton && cartPopupWrapper) {
    closeButton.addEventListener('click', function() {
      cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');
    });
    dismissButton.addEventListener('click', function() {
      cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');
    });
  }
}

// Add close button listener
document.addEventListener('DOMContentLoaded', function() {
  addCloseButtonEventListener();
});

function searchanizeProcess() {
  return new Promise(async function(resolve, reject) {
    const extractProductId = function (r) { return r.getAttribute("id").replace(/^.*-([^-]+)$/, "$1"); };
    const extractProductHandle = function (h) { return (h.getAttribute("href").split('/')).pop(); }
    async function getProductObject(handle) {
      handle = (handle.split('?'))[0];
      return new Promise(async(resolve,reject)=>{
        try { await $.getJSON(`/products/${handle}.js`,function(product) { return resolve(product); });
        } catch (error) { return resolve({id:''}); }
      });
    }
    await $(document).on("Searchanise.ResultsUpdated", async function (ev, $results) {

      const viewportWidth = screen.width; 
      const prevCollectionLinkPc = document.querySelector('.product-list__all-collection-pc');
      const prevCollectionLinkSp = document.querySelector('.product-list__all-collection-sp');
      const pcFiltersDiv = document.querySelector('.snize-filters-sidebar');
      const spFiltersDiv = document.querySelector('.snize-product-filters-buttons-container');
      const pcAllCollectionLink = `<a class="product-list__all-collection-pc" href="/collections/all"><div id="snize_filters_block_stock_status" class="snize-product-filters-block" style="display: block"><div class="snize-product-filters-title" style="margin-left: 20px"><span>全てのアイテム</span></div></div></a>`;
      const spAllCollectionLink = `<a class="product-list__all-collection-sp" href="/collections/all"><button class="snize-product-filters-show-products">全てのアイテム</button></a>`;

      if (!prevCollectionLinkPc) {
        if (pcFiltersDiv) {
          pcFiltersDiv.insertAdjacentHTML('afterbegin', pcAllCollectionLink);
        }
      };

      if (!prevCollectionLinkSp) {
        if (spFiltersDiv) {
          spFiltersDiv.insertAdjacentHTML('beforeend', spAllCollectionLink);
        }
      };

      let productIds = [];
      await $results.find(".snize-product").each(function () { productIds.push(extractProductId(this)); });
      let productHandles = [];
      await $results.find(".snize-view-link").each(function () { extractProductHandle(this); productHandles.push(extractProductHandle(this));});
      let productArray = [];
      for (let i = 0; i < productHandles.length; i++) {
        const productObject = await getProductObject(productHandles[i]);
        productArray.push(productObject);
      }
      await $results.find(".snize-product").each(async function () {
        const searchProduct = productArray.filter(p => p.id == extractProductId(this));
        if (searchProduct.length > 0) {

          const productObjectData = searchProduct[0];

          const $itemHeader = $(this).find(".snize-custom-item-header").empty();
          let category = '';
          let catchPhrase = '';
          let tasteText = '';
          let tasteBody = '';
          let prefecture = '';

          if (productObjectData.tags && 0 < productObjectData.tags.length) {
            const $ul = $('<ul class="tag_wrap p_tag_wrap txt_pankuzu mb_s2"></ul>').appendTo($itemHeader);

              var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone)/i);
		      var j = 0;
              var k = 0;

              if(isMobile){
                  k = 4
              }else{
                  k = 1000
              }

              for (var i=0; i<searchTagList.length && j<k; i++)
                { 
                  if(productObjectData.tags.includes(searchTagList[i])) {
                    const $li = $("<li />").addClass(searchTagList[i].replace('関連キーワード_','')).appendTo($ul);
                    $li.text(searchTagList[i] == "関連キーワード_受賞ワイン" ? "受賞": searchTagList[i].replace("関連キーワード_", ""));
  				  j++;
                  }
                }

            productObjectData.tags.forEach(function (tag) {
              if (tag.includes('都道府県_')) { prefecture = tag.replace('都道府県_',''); }
              if (tag.includes('meta-ProductType2:')) { category = tag.replace('meta-ProductType2:',''); }
              if (tag.includes('meta-CatchPhrase:')) { catchPhrase = tag.replace('meta-CatchPhrase:',''); }
              if (tag.includes('meta-TasteText:')) { tasteText = tag.replace('meta-TasteText:',''); }
              if (tag.includes('meta-Body:')) { tasteBody = tag.replace('meta-Body:',''); }
            });
          }
          const $paragraphForCategoryAndTaste = $('<p class="mb_s1 snize-sp-upperfont" />').appendTo($itemHeader);
          const $span = $('<span class="bold pr_10 product-type2" />').appendTo($paragraphForCategoryAndTaste);
          if (category === "シードル" || category === "ポワレ") {$(this).find(".snize-thumbnail-wrapper").addClass("シードル／ポワレ");
          } else { $(this).find(".snize-thumbnail-wrapper").addClass(category);}
          $(this).find(".product-type2").text(category);
          $('<br class="sp_only" />').appendTo($paragraphForCategoryAndTaste);
          const tasteBodyAndTextLength = tasteBody.length + tasteText.length;
          const $spans = $(`<span class="pr_10 tastebody">${tasteBody}</span><span class="pr_10 taste_slash"></span>${viewportWidth < 340 && tasteBodyAndTextLength > 11 ? '<br class="sp_only" />' : ''}<span class="pr_10 tastetext">${tasteText}</span>`).appendTo(
            $paragraphForCategoryAndTaste
          );
          if (tasteBody !== '' && tasteText !== '') { $(this).find(".taste_slash").text('/'); }
          if (productObjectData.vendor && productObjectData.vendor != "wa-syu") {
            const wineryLength = productObjectData.vendor.length;
            const lineBreakMargin = wineryLength > 7 ? `class="prefecture-margin"` : ``;
            const prefectureLineBreak = wineryLength > 7 ? `<br class="sp-only">` : ``;
            const prefectureString = prefecture ? `<span class="pr_10">/</span>${prefectureLineBreak}<span ${lineBreakMargin}>${prefecture}</span>` : ``;
            const $p = $('<p class="mb_s2 snize-sp-upperfont" />').appendTo($itemHeader);
            $p.html(`<span class="pr_10">${productObjectData.vendor}</span>${prefectureString}`);
          }
          $(this).find("div.snize-price-list").empty();
          if (productObjectData.compare_at_price === null) {
            $(this).find("div.snize-price-list").html(`<span class="snize-price money">¥${String(productObjectData.price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>`);
          } else {
            $(this).find("div.snize-price-list").html(`<span class="snize-discounted-price money">¥${String(productObjectData.compare_at_price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span><span class="snize-price snize-price-with-discount money">¥${String(productObjectData.price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>`);
          }
          $(this).find(".snize-description>p").addClass('').empty().text(catchPhrase);
          $('div.snize-options-box').remove();
          $(`#snize-product-${extractProductId(this)}`).css('display', '');
          $(this).find(".snize-thumbnail>img").addClass('howatto-hover');
          $(this).find(".snize-thumbnail").addClass('howatto-hover');
          if (productObjectData.available === false) {
            $(this).find(".snize-thumbnail").addClass('list_item_img_soldout');
            $(this).find(".snize-thumbnail").css('opacity', '0.5');
          }
          if (productObjectData.images.length > 1) {
            $(this).find(".snize-thumbnail>img").attr('src',productObjectData.images[1]);
          }

          // Call the function to append the button
          insertCartButton(this, productObjectData);
          
        }
      });
    });
    return resolve(true);
  });
}
searchanizeProcess();
